// extracted by mini-css-extract-plugin
export default {"settings_item":"style_settings_item__sNIct","submit":"style_submit__uL+lM"};